var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1344_137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99937 1.61816V3.01816C11.3338 3.48996 12.4585 4.4183 13.1746 5.63912C13.8908 6.85995 14.1523 8.29464 13.913 9.68963C13.6736 11.0846 12.9488 12.3501 11.8667 13.2624C10.7845 14.1747 9.41474 14.675 7.99937 14.675C6.58399 14.675 5.21418 14.1747 4.13205 13.2624C3.04991 12.3501 2.32512 11.0846 2.08578 9.68963C1.84643 8.29464 2.10795 6.85995 2.8241 5.63912C3.54026 4.4183 4.66494 3.48996 5.99937 3.01816V1.61816C4.29645 2.1009 2.82558 3.18326 1.8582 4.66553C0.890808 6.14781 0.492178 7.92995 0.735865 9.68312C0.979552 11.4363 1.84911 13.0421 3.18408 14.2044C4.51905 15.3666 6.22935 16.0068 7.99937 16.0068C9.76939 16.0068 11.4797 15.3666 12.8147 14.2044C14.1496 13.0421 15.0192 11.4363 15.2629 9.68312C15.5066 7.92995 15.1079 6.14781 14.1405 4.66553C13.1731 3.18326 11.7023 2.1009 9.99937 1.61816Z",
    fill: "#212529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66537 0H7.33203V5.33333H8.66537V0Z",
    fill: "#212529"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1344_137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownLogout);
export default __webpack_public_path__ + "static/media/dropdownLogout.f50ccfb559436d6a0cf74d80b7c4ece6.svg";
export { ForwardRef as ReactComponent };